import { ITableColumn, TableColumnTypeEnum, WidthType } from "./tableColumn.interface";

export const InventoryTableColumns: ITableColumn[] = [
    {
        labelPath: "inventoryPage.tableColumns.resourceName",
        propertyKey: "resourceName",
        colType: TableColumnTypeEnum.TextWithIconAndTooltip,
        width: 280,
        widthType: WidthType.Pixel,
        isSortable: true,
        sortKey: "displayName",
        descriptionLabelPath: "commonEntitiesInfo.resourceName",
        iconSrc: "iconSrcResourceName",
        tooltipIconText: "toolTipResourceName",
    },
    {
        labelPath: "inventoryPage.tableColumns.resourceType",
        propertyKey: "resourceType",
        colType: TableColumnTypeEnum.Text,
        width: 400,
        widthType: WidthType.Pixel,
        isSortable: true,
        sortKey: "type",
        descriptionLabelPath: "commonEntitiesInfo.resourceType",
    },
    {
        labelPath: "inventoryPage.tableColumns.environment",
        propertyKey: "environment",
        colType: TableColumnTypeEnum.TextOrNA,
        width: 240,
        widthType: WidthType.Pixel,
        toCapitalize: true,
        isSortable: true,
        sortKey: "environmentName",
        tooltipDynamicText: "notApplicableEnvTooltipText",
        descriptionLabelPath: "commonEntitiesInfo.environment",
    },
    {
        labelPath: "inventoryPage.tableColumns.createdBy",
        propertyKey: "createdBy",
        colType: TableColumnTypeEnum.TextOrNA,
        width: 160,
        widthType: WidthType.Pixel,
        isSortable: true,
        sortKey: "createdByName",
        tooltipDynamicText: "notApplicableCreatedByTooltipText",
        descriptionLabelPath: "commonEntitiesInfo.createdBy",
    },
    {
        labelPath: "inventoryPage.tableColumns.ownedBy",
        propertyKey: "ownedBy",
        colType: TableColumnTypeEnum.MultiValueOrNA,
        width: 160,
        widthType: WidthType.Pixel,
        isSortable: false,
        tooltipDynamicText: "notApplicableOwnedByTooltipText",
        descriptionLabelPath: "commonEntitiesInfo.ownedBy",
    },
    {
        labelPath: "inventoryPage.tableColumns.creationTime",
        propertyKey: "creationTime",
        colType: TableColumnTypeEnum.TextOrNA,
        width: 160,
        widthType: WidthType.Pixel,
        isSortable: true,
        sortKey: "creationTime",
    },
    {
        labelPath: "inventoryPage.tableColumns.businessCriticality",
        propertyKey: "businessCriticality",
        colType: TableColumnTypeEnum.SeverityLabel,
        width: 160,
        widthType: WidthType.Pixel,
        isSortable: true,
        sortKey: "businessCriticality",
        descriptionLabelPath: "commonEntitiesInfo.businessCriticality",
    },
    {
        labelPath: "inventoryPage.tableColumns.securityRisk",
        propertyKey: "securityRisk",
        colType: TableColumnTypeEnum.SeverityLabel,
        width: 130,
        widthType: WidthType.Pixel,
        isSortable: true,
        sortKey: "securityRisk",
        descriptionLabelPath: "commonEntitiesInfo.securityRisk",
    },
    {
        labelPath: "inventoryPage.tableColumns.resourceStatus",
        propertyKey: "statusLabel",
        colType: TableColumnTypeEnum.StatusLabel,
        isSortable: true,
        sortKey: "status",
        width: 144,
        widthType: WidthType.Pixel,
    },
];
